import styled from "styled-components";
import { alpha } from "../../typography";
import { Icon } from "../Icon";

export const StyledIcon = styled(Icon)`
  cursor: pointer;

  svg {
    --main-color: var(--color-neutral-800);
  }
`;

export const Chip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  height: 20px;
  box-sizing: border-box;
  padding: 4px 4px 4px 8px;
  ${alpha.primaryActive.caption}
  line-height: 12px;
  color: var(--color-primary-900);
  background-color: var(--color-secondary-400);
  border-radius: 10px;

  &.danger {
    background-color: var(--color-error-200);
  }
`;

export const ErrorMessage = styled.div`
  ${alpha.primaryActive.caption}
  color: var(--color-error-500);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextFieldContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid var(--color-primary-400);
  gap: 6px;
  padding: 6px 8px;
  border-radius: 5px;
  box-sizing: border-box;

  &.danger {
    border-color: var(--color-error-500);
  }

  > :last-child {
    border: none !important;
    flex-grow: 1;
    height: 20px;
    background: inherit;
    input {
      padding: 0;
    }
  }
`;
